import { Button } from '@/components/ui'

export function ErrorFallback() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-primary-bg">
      <div className="text-center max-w-md px-6">
        <h1 className="text-2xl font-semibold text-primary-text mb-4">
          Something went wrong
        </h1>
        <p className="text-secondary-text mb-6">
          An unexpected error occurred. Please try reloading the page.
        </p>
        <Button onClick={() => window.location.reload()}>
          Reload page
        </Button>
      </div>
    </div>
  )
}
